import React, { useEffect } from "react";

import Main from '../components/Home/Main'
import TradeWhatEver from "../components/Home/TradeWhatEver";
import Bonus from "../components/Home/Bonus";
import Various from "../components/Home/Various";
import PowerfulTrading from "../components/Home/PowerfulTrading";
import SimpleSteps from "../components/Home/SimpleSteps";

function Home () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="">
            <Main/>
            <TradeWhatEver/>
            <Bonus/>
            <Various/>
            <PowerfulTrading/>
            <SimpleSteps/>
        </div>
    );
}

export default Home;